import { useState as a, useEffect as o } from "react";
const i = () => {
  const [e, n] = a(window.location.pathname);
  return o(() => {
    const t = () => {
      n(window.location.pathname);
    };
    return window.addEventListener("popstate", t), () => window.removeEventListener("popstate", t);
  }, []), e;
};
export {
  i as usePathname
};
